import { render, staticRenderFns } from "./Lotteries.vue?vue&type=template&id=228a20b9&"
import script from "./Lotteries.vue?vue&type=script&lang=js&"
export * from "./Lotteries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports